import React, { useEffect, useState, useRef } from 'react';
import { connect } from 'react-redux';
import { TextField } from '@material-ui/core';
import Container from '@material-ui/core/Container';

import './styles.css'

const Informacoes = (props) => {
  const [data, setData] = useState(props.data)
  const latestData = useRef(data)

  const handleInputText = ({target: {name, value}}) => {
    setData({...data, [name]: value});
  };

  const handleDataChanged = () => {
    const { dispatch } = props
    dispatch({
      type: 'ADD_TO_FORM',
      data: {
        Informacoes: latestData.current,
      },
    })
  }

  useEffect(() => {
    latestData.current = data
  }, [data])

  useEffect(() => {
    return () => handleDataChanged()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])


  return (
    <Container maxWidth="lg" className="container">
      <h1 className="mobile-title" style={{display: 'none'}}>5. Outras Informações</h1>
      <div className="Form01">
      {<TextField
          autoFocus
          label="Outras Informações Adicionais"
          name="OutrasInformacoes"
          multiline
          rows={16}
          fullWidth
          defaultValue = {data.OutrasInformacoes}
          onChange={handleInputText}
          placeholder="Insira neste espaço outras informações que sejam importantes para a licença"
          variant="outlined"
        />}
      </div>
    </Container>
  )
}

export default connect((state) => ({
  data: state.form.Informacoes,
}))(Informacoes)
